import React from "react"
import ReactDOM from "react-dom/client"

import { SearchspringAutocompleteProvider } from "@app/scripts/providers/searchspring"

import { InstantSearch, type Props } from "./component"

const App = class extends HTMLElement {
  root: ReactDOM.Root | null = null

  connectedCallback() {
    const props: Partial<Props> = {}

    this.querySelectorAll("script").forEach((script) => {
      try {
        const data = JSON.parse(script?.innerHTML)
        const name = script.getAttribute("name")

        if (!name) return

        props[name as keyof Props] = data
      } catch (error) {
        console.error(error)
      }
    })

    if (!this.root) this.root = ReactDOM.createRoot(this)
    this.root.render(
      <SearchspringAutocompleteProvider
        category="products"
        resultsPerPage="5"
        isInitiallyRun={false}
      >
        <InstantSearch {...(props as Props)} />
      </SearchspringAutocompleteProvider>
    )
  }
}

customElements.define("ss-search-drawer", App)
